var axios = require('axios');
axios.defaults.timeout = 5000;

// //loading
// function showLoad(){
//     var body = document.body;
//     var div = document.createElement("div");
//     div.id="loadDiv"
//     div.innerHTML = "<div class=\"loadtop\"><div class=\"toast\"><img src=\"/static/images/loading.gif\" /></div></div>";
//     body.appendChild(div);

// }

// //移除loading
// function hideLoading(){
//     var my = document.getElementById("loadDiv");
//     if (my != null){
//         my.parentNode.removeChild(my);
//     }
// }

/*
  接口处理函数
*/

function apiAxios(method, url, params, success, failure, complete) {
   
    if (method === 'POST' || method === 'PUT') {
        let qs = require("qs");
        params = qs.stringify(params);
    }
    //显示loading
    $.showLoading();
    axios({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
        baseURL: "",
        timeout: 60000,
        withCredentials: false
    })
        .then(function (res) {
            try {
                //移除load
                $.hideLoading();
                // 统一授权过期判断
                if (success) {
                    success(res.data)
                }
            } catch (error) {

            }
            if (typeof complete == "function") {
                complete();
            }
        })
        .catch(function (err) {
            if (typeof complete == "function") {
                complete();
            }
            //移除load
            $.hideLoading();

            if (err && err.response) {
                let res = err.response;
                if (res.status) {
                    
                    // switch (res ? (res.status || "") : "") {
                    //     case 400:
                    //         $.alert('操作失败,请求错误');
                    //         break;
                    //     case 401:
                    //         $.alert('未授权，请登录');
                    //         break;
                    //     case 403:
                    //         $.alert('操作失败,拒绝访问');
                    //         break;
                    //     case 404:
                    //     $.alert('操作失败,请求地址出错');
                    //         break;
                    //     case 408:
                    //     $.alert('操作失败,请求超时');
                    //         break;
                    //     case 500:
                    //         // err.message = '服务器内部错误'
                    //         $.alert('操作失败,网络异常');
                    //         break;
                    //     case 501:
                    //         //err.message = '服务未实现'
                    //         $.alert('操作失败,网络异常');
                    //         break;
                    //     case 502:
                    //         //err.message = '网关错误'
                    //         $.alert('操作失败,网络异常');
                    //         break;
                    //     case 503:
                    //     $.alert('操作失败,服务不可用');
                    //         break;
                    //     case 504:
                    //     $.alert('操作失败,网关超时');
                    //         break;
                    //     case 505:
                    //     $.alert('操作失败,HTTP版本不受支持');
                    //         break;
                    //     default:
                    // }
                    if (failure) {
                        failure(err);
                    }
                }
                else {
                    if (failure) {
                        failure(err);
                    }
                }
            }
            else if (err && err.message && err.message.indexOf("timeout of ") == 0) {
                $.alert('请求超时，请稍后重试!');
            }
            else {
                if (failure) {
                    failure(err);
                }
            }
        })
}

// 返回在vue模板中的调用接口
export default {
    get: function (url, params, success, failure) {
        return apiAxios('GET', url, params, success, failure)
    },
    post: function (url, params, success, failure) {
        return apiAxios('POST', url, params, success, failure)
    },
    /*
    option: {
        method: "GET,POST,PUT,DELETE",
        url: "接口地址",
        params: object, //上送参数
        success: function, 成功后的回调方法,
        failure: function, 接口请求失败的回调方法,
        isShowLoading：true //是否显示进度条，默认值为true
        loadMsg:""//进度条显示提示语
    }
    */
    ajax: function (option) {
        return apiAxios(
            option.method || 'POST'
            , option.url
            , option.params
            , option.success
            , option.failure
            , option.isShowLoading
            , option.loadMsg
            , option.notLoginBackUrl
            , option.complete
        );
    },
    put: function (url, params, success, failure) {
        return apiAxios('PUT', url, params, success, failure)
    },
    delete: function (url, params, success, failure) {
        return apiAxios('DELETE', url, params, success, failure)
    }
}


// WEBPACK FOOTER //
// ./src/http/index.js